'use strict';

/* eslint-disable */

function showOneyLearnMoreContent() {
    let oneySettings = JSON.parse($('#oney_settingsJson').val());
    let countryCode = $('#oney_countryCode').val();
    let paymentAmt = $('#oney_paymentAmt').val();

    let modalOverlayContainerHtml = `<div id="osm_oney_learn_more_container"><div class="content"></div></div>`;
    $('#osm_oney_learn_more_container').remove();
    $('body').prepend(modalOverlayContainerHtml);

    let options = {
        country: countryCode,
        language: countryCode,
        merchant_guid: oneySettings.merchantGuid,
        payment_amount: paymentAmt,
        filter_by: 'filters',
        filters: [
            {
                payment_mode: `${oneySettings.numberOfInstallments}x`,
                is_free: !oneySettings.includeInterest
            }
        ],
        checkout_placeholder: '#osm_oney_learn_more_container > div.content'
    };

    let checkRenderedPtr = null;
    options.errorCallback = function (status, response) {
        console.log('showOneyLearnMoreContent error, ', 'status: ', status, 'response: ', response);
        $('#osm_oney_learn_more_container').remove();
        if (checkRenderedPtr) {
            clearInterval(checkRenderedPtr);
        }
    };

    loadOneyWidget(function () {
        checkRenderedPtr = setInterval(() => {
            let sel = $('#osm_oney_learn_more_container > div.content > div.oney-checkoutSection');
            if (sel.length) {
                clearInterval(checkRenderedPtr);

                sel.css('background-color', 'white');
                let closeBtnHtml = `
                    <div style="display: flex; justify-content: space-between;">
                        <div></div>
                        <div style="padding: 4px; cursor: pointer;" title="Close" onclick="$('#osm_oney_learn_more_container').remove()">
                        <strong>X</strong></div>
                    </div>
                `;
                sel.prepend(closeBtnHtml);
            }
        }, 100);
        oneyMerchantApp.loadCheckoutSection({ options });
    });
}

$(document).on('click', '#oney_learn', showOneyLearnMoreContent);
